// src/pages/LoginPage.js
import React from 'react';
import LoginComponent from '../components/auth/Login';
import signInImage from '../assets/signPageImg.jpg'; // <-- IMPORT THE IMAGE HERE
import { Link } from 'react-router-dom'; // Make sure Link is imported
import logo from '../assets/logo.svg'; // Import the logo

function LoginPage() {
  const imageSrc = signInImage; // Use the imported image variable

  return (
    <section className="min-h-screen">
      <div className="absolute top-4 right-4 md:top-6 md:right-6 z-10"> {/* Adjust margins as needed */}
        <Link to="/">
          <img src={logo} width={150} height={40} alt='Company Logo' />
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
        {/* Left side - Image */}
        <div className="relative hidden md:block"> {/* Hide on small screens, show on md and up */}
          <img
            src={imageSrc} // <-- USE THE IMPORTED VARIABLE
            alt="Sign in background"
            className="absolute inset-0 w-full h-full object-cover" 
          />
        </div>
        
        {/* Right side - Sign In Form */}
        <div className="flex items-center justify-center p-4 sm:p-8 bg-gray-50">
          <LoginComponent />
        </div>
      </div>
    </section>
  );
}

export default LoginPage;